import { HttpMethod, HttpOption } from '@/utils/http-client'
import { AccountPageRequestModel, OpenAccountParams, RechargeAccountParams, StateParam,ReleaseParams,RepaymentParams } from '@/api/model/account'

export class AccountAPIConstant {
    accountPage = (data: AccountPageRequestModel): HttpOption => ({
        url: '/fundcloud/account/selectCompanyAccountPage',
        method: HttpMethod.POST,
        data
    })

    openAccount = (data: OpenAccountParams): HttpOption => ({
        url: '/fundcloud/account/openAccount',
        method: HttpMethod.POST,
        data
    })

    getBankList = (): HttpOption => ({
        url: '/fundcloud/account/getBankIdlist',
        method: HttpMethod.GET
    })

    recharge = (data: RechargeAccountParams): HttpOption => ({
        url: '/fundcloud/account/rechargeCompanyAccount',
        method: HttpMethod.POST,
        data
    })

    updateState = (data: StateParam): HttpOption => ({
        url: '/fundcloud/account/updateAccountState',
        method: HttpMethod.POST,
        data
    })

    getReleaseList = (data: ReleaseParams): HttpOption => ({
        url: '/fundcloud/loan/report/releaseList',
        method: HttpMethod.POST,
        data
    })
    getRepaymentList = (data: RepaymentParams): HttpOption => ({
        url: '/fundcloud/loan/report/repaymentList',
        method: HttpMethod.POST,
        data
    })

    getDailyBusinessList = (data: RepaymentParams): HttpOption => ({
        url: '/fundcloud/loan/report/dailyBusinessList',
        method: HttpMethod.POST,
        data
    })
}
